// extracted by mini-css-extract-plugin
export var cartContainer = "_pv-4";
export var gray = "_pv-1";
export var itemContainer = "_pv-2";
export var itemDetails = "_pv-3";
export var strong = "_pv-0";